import UserVideoModal from "../UserVideoModal";
import UserPDFReaderModal from "../UserPDFReaderModal";

const ContentViewer = ({ viewerType, viewerSrc, selectedRecord, courseId, userId, videoModalRef, pdfModalRef, closeViewer, closeContentViewer, sidebarVisible, isMobile,onNextContent, isContentCompleted, markSidebarItemAcknowledged }) => {
   
    return(
    <div className={`
        flex-1 bg-white flex justify-center items-center overflow-hidden relative
        transition-all duration-300 min-h-8 z-[1]
        ${isMobile && sidebarVisible ? "blur-sm pointer-events-none" : "blur-none pointer-events-auto"}
    `}>
        {viewerType === "video" && viewerSrc  && (
            <div className="relative w-full h-full z-[1] bg-[rgba(253,252,252,0.9)] flex items-center justify-center">
                <UserVideoModal
                    ref={videoModalRef}
                    isOpen={true}
                    fileName={viewerSrc}
                    resourceType={viewerType}
                    onClose={closeViewer}
                    key={selectedRecord?.contentId ?? selectedRecord?.courseContentId}
                    contentId={selectedRecord?.contentId ?? selectedRecord?.courseContentId}
                    courseId={courseId}
                    userId={userId}
                    handleClose={closeContentViewer}
                    isAcknowledged={selectedRecord?.acknowledged || false}
                    onSuccess={onNextContent}
                    isContentCompleted={isContentCompleted}
                />
            </div>
        )}

        {viewerType === "pdf" && viewerSrc && (
            <div key={viewerSrc} className="relative w-full h-full z-[1] bg-[#f5f5f5] overflow-hidden">
                <UserPDFReaderModal
                    ref={pdfModalRef}
                    isOpen={true}
                    fileName={viewerSrc}
                    onClose={closeViewer}
                    key={selectedRecord?.contentId ?? selectedRecord?.courseContentId}
                    contentId={selectedRecord?.contentId ?? selectedRecord?.courseContentId}
                    courseId={courseId}
                    userId={userId}
                    blockTime={selectedRecord?.completionPercentage > 95 ? 0 : 10}
                    isAcknowledged={selectedRecord?.acknowledged || false}
                    handleClose={closeContentViewer}
                    onSuccess={onNextContent}   
                    isContentCompleted={isContentCompleted}
                    markSidebarItemAcknowledged={markSidebarItemAcknowledged}
                />
            </div>
        )}
    </div>
);
};

export default ContentViewer;